import type { AppDefinition } from '../../types/apps';

export const MediaViewerAppDefinition: AppDefinition = {
  appId: 'mediaviewer',
  name: 'Media Viewer',
  version: '1.0.0',
  description: 'View images, videos, and other media files.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Image',
    phosphorWeight: 'duotone',
    color: '#a855f7',
  },
  component: 'MediaViewerApp',
  entityTypes: [],
  requiresProps: false,
  requiresEntity: false,
};
